import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";
import Hospitals from "../components/Hospitals";

export const HospitalsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "For Hospitals & Nursing Homes — Lokam Health";
  }, []);

  return (
    <div className="bg-lokam-cream min-h-screen">
      <Header />
      <main>
        <Hospitals />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default HospitalsPage;
